import request from '@/utils/request';

// 登录方法
export function login(
  username: string,
  password: string,
  code: string,
  uuid: string,
) {
  const data = {
    username,
    password,
    code,
    uuid,
  };
  return request({
    url: '/login',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: data,
  });
}

// caLogin
export function caLogin(token: string) {
  return request({
    url: '/caLogin',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: {
      token,
    },
  });
}

// 获取相应 ca login 的账户信息
export function queryCaLoginAccount(token: string) {
  return request({
    url: '/caAutoCreatePassword',
    method: 'post',
    data: {
      token,
    },
  });
}

// 手机号登录方法
export function smsLogin(
  mobile: string,
  code: string,
  uuid: string,
  smsUuid: string,
  smsCode: string,
) {
  const data = {
    mobile,
    code,
    uuid,
    smsUuid,
    smsCode,
    smsFlag: true,
  };
  return request({
    url: '/login',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: data,
  });
}

// 注册方法
export function register(data: any) {
  return request({
    url: '/register',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get',
  });
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false,
    },
    method: 'get',
    timeout: 20000,
  });
}

// 获取用户账号信息
export function getAccountInfo() {
  return request({
    url: '/system/real/getAccountInfo',
  });
}

// 切换用户账号信息
export function switchAccountInfo(targetDeptId: string) {
  return request({
    url: '/system/real/switchAccountInfo',
    method: 'post',
    data: {
      targetDeptId,
    },
  });
}

export const getBusinessNodeId = () => {
  return request({
    method: 'get',
    url: '/baseBusinessNode/getDsNodeId',
  });
};
